import React, { Suspense, useLayoutEffect } from "react";
import Toastify from "./utils/tostfy";
import ApiAlertModal from "./Components/ApiAlertModal/ApiAlertModal";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { DataProvider } from "./Components/DataContext";
import { handleUnauthenticatedAccess, readLoginState } from "./utils/authGuard";
import AddNew from "./Pages/UserRoleManagement/AddNew ";
import Reports from "./Pages/Reports/Reports";
import ContentManagementSystem from "./Pages/ContentManagementSystem/ContentManagementSystem";
import DriverManagement from "./Pages/DriverManagement/DriverManagement";
import AccountantManagement from "./Pages/AccountantManagement/AccountantManagement";
import AddNewAccount from "./Pages/AccountantManagement/AddNew ";
import EditAccountant from "./Pages/AccountantManagement/EditAccountant";
import ViewAccountantDetails from "./Pages/AccountantManagement/ViewAccountantDetails";
import ViewTripDetails from "./Pages/AccountantManagement/ViewTripDetails";
import FuelOperatorManagement from "./Pages/FuelOperatorManagement/FuelOperatorManagement";
import AddNewFuelOperator from "./Pages/FuelOperatorManagement/AddNewFuelOperator";
import EditFuelOperator from "./Pages/FuelOperatorManagement/EditFuelOperator";
import ViewFuelOperatorDetails from "./Pages/FuelOperatorManagement/ViewFuelOperatorDetails";
import ViewFuelDetails from "./Pages/FuelOperatorManagement/ViewFuelDetails";
import FuelFilledHistory from "./Pages/FuelFilledHistory/FuelFilledHistory";
import FuelDetails from "./Pages/FuelFilledHistory/FuelDetails";
import FuelPumpManagement from "./Pages/FuelPumpManagement/FuelPumpManagement";
import FuelSettlementDetails from "./Pages/FuelPumpManagement/FuelSettlementDetails";
import SubAdminManagement from "./Pages/SubAdminManagement/SubAdminManagement";
import CreateSubAdmin from "./Pages/SubAdminManagement/CreateSubAdmin";
import EditSubAdmin from "./Pages/SubAdminManagement/EditSubAdmin";
import SalaryAwards from "./Pages/SalaryAwards/SalaryAwards";
import SalaryAwardsDetail from "./Pages/SalaryAwards/SalaryAwardsDetail";
import ViewTransactions from "./Pages/SalaryAwards/ViewTransactions";
import MyRequests from "./Pages/MyRequests/MyRequests";
import ViewRequestDetails from "./Pages/MyRequests/ViewRequestDetails";
import CompanyMaster from "./Pages/MasterManagement/CompanyMaster/CompanyMaster";
import VehicleMaster from "./Pages/MasterManagement/VehicleMaster/VehicleMaster";
import LocationMaster from "./Pages/MasterManagement/LocationMaster/LocationMaster";
import FuelPumpMaster from "./Pages/MasterManagement/FuelPumpMaster/FuelPumpMaster";
import AwardMaster from "./Pages/MasterManagement/AwardMaster/AwardMaster";
import ViewFuelPumpDetails from "./Pages/MasterManagement/FuelPumpMaster/ViewFuelPumpDetails";
import RouteMaster from "./Pages/MasterManagement/RouteMaster/RouteMaster";
import AddRoute from "./Pages/MasterManagement/RouteMaster/AddRoute";
import ViewRoute from "./Pages/MasterManagement/RouteMaster/ViewRoute";
import ViewDriverDetails from "./Pages/DriverManagement/ViewDriverDetails";
import EditDriverDetails from "./Pages/DriverManagement/EditDriverDetails";
import TripHistoryListing from "./Pages/TripHistory/TripHistoryListing";
import TripHistoryDetailsView from "./Pages/TripHistory/TripHistoryDetailsView";
const Layout = React.lazy(() => import("./Components/Layout/Layout"));
const Spinnerr = React.lazy(() => import("./Components/Spinner/Spinner"));
const Login = React.lazy(() => import("./Pages/Login/Login"));
const Verifiy = React.lazy(() => import("./Pages/Login/VerifiyOpt"));
const UpdatePassword = React.lazy(() => import("./Pages/Login/UpdatePassword"));
const Dashboard = React.lazy(() => import("./Pages/Dashboard/Dashboard"));
const ForgotPassword = React.lazy(() => import("./Pages/Login/ForgotPassword"));
const AuthLayout = React.lazy(() => import("./Components/Layout/AuthLayout"));
function App() {
  const PrivateOutlet = () => {
    const loginSuccess = useSelector((state) => state.loginInfo?.userInformation);
    const { isLoggedIn } = readLoginState(loginSuccess);

    useLayoutEffect(() => {
      if (!isLoggedIn) {
        handleUnauthenticatedAccess();
      }
    }, [isLoggedIn]);

    if (!isLoggedIn) {
      return <Navigate to="/" replace />;
    }

    return <Outlet />;
  };

  const UnknownRouteRedirect = () => {
    const loginSuccess = useSelector((state) => state.loginInfo?.userInformation);
    const { isLoggedIn } = readLoginState(loginSuccess);
    return <Navigate to={isLoggedIn ? "/dashboard" : "/"} replace />;
  };

  return (
    <DataProvider>
    <Router>
      <Toastify />
      <ApiAlertModal />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<AuthLayout />}>
            <Route index element={<Login />} />
            <Route path="update-password" element={<UpdatePassword />} />
            <Route path="resetPassword" element={<UpdatePassword />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="verify-password" element={<Verifiy />} />
          </Route>
          <Route element={<PrivateOutlet />}>
            <Route element={<Layout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="/driver-management" element={<DriverManagement />} />
              <Route path="/driver-management/view-driver-details" element={<ViewDriverDetails />} />
              <Route path="/driver-management/edit-driver-details" element={<EditDriverDetails />} />
              <Route path="/trip-history" element={<TripHistoryListing />} />
              <Route path="/trip-history/view-trip-history-details" element={<TripHistoryDetailsView />} />                 
              <Route path="/user-role-management/add-new" element={<AddNew />} />
              <Route path="/accountant-management" element={<AccountantManagement />} />
              <Route path="/accountant-management/add-new" element={<AddNewAccount />} />
              <Route path="/accountant-management/edit" element={<EditAccountant />} />
              <Route path="/accountant-management/view" element={<ViewAccountantDetails />} />
              <Route path="/accountant-management/view-trip" element={<ViewTripDetails />} />
              <Route path="/fuel-operator-management" element={<FuelOperatorManagement />} />
              <Route path="/fuel-operator-management/add-new" element={<AddNewFuelOperator />} />
              <Route path="/fuel-operator-management/edit" element={<EditFuelOperator />} />
              <Route path="/fuel-operator-management/view" element={<ViewFuelOperatorDetails />} />
              <Route path="/fuel-operator-management/view-fuel-details" element={<ViewFuelDetails />} />
              <Route path="/fuel-filled-history" element={<FuelFilledHistory />} />
              <Route path="/fuel-filled-history/view" element={<FuelDetails />} />
              <Route path="/fuel-pump-management" element={<FuelPumpManagement />} />
              <Route path="/fuel-pump-management/view-settlement-details" element={<FuelSettlementDetails />} />
              <Route path="/sub-admin-management" element={<SubAdminManagement />} />
              <Route path="/sub-admin-management/create-sub-admin" element={<CreateSubAdmin />} />
              <Route path="/sub-admin-management/edit-sub-admin" element={<EditSubAdmin />} />
              <Route path="/salary-awards" element={<SalaryAwards />} />
              <Route path="/salary-awards/salary-and-awards-detail" element={<SalaryAwardsDetail />} />
              <Route path="/my-requests" element={<MyRequests />} />
              <Route path="/my-requests/view-request-retails" element={<ViewRequestDetails />} />
              <Route path="/salary-awards/salary-and-awards-detail/view-transactions" element={<ViewTransactions />} />
              <Route path="/reports" element={<Reports />} /> 
              <Route path="/content-management-system" element={<ContentManagementSystem />} /> 
              <Route path="/company-master" element={<CompanyMaster />} /> 
              <Route path="/vehicle-master" element={<VehicleMaster />} /> 
              <Route path="/location-master" element={<LocationMaster />} /> 
              <Route path="/fuel-pump-master" element={<FuelPumpMaster />} /> 
              <Route path="/fuel-pump-master/view-details" element={<ViewFuelPumpDetails />} /> 
              <Route path="/route-master" element={<RouteMaster />} /> 
              <Route path="/route-master/add-route" element={<AddRoute />} /> 
              <Route path="/route-master/view-route" element={<ViewRoute />} /> 
              <Route path="/award-master" element={<AwardMaster />} /> 
            </Route>
          </Route>
          <Route path="*" element={<UnknownRouteRedirect />} />
        </Routes>
      </Suspense>
    </Router>
    </DataProvider>
  );
}

export default App;
